import "./css/NavigationLoader.css";

import { Box } from '@mui/material';
import NProgress from 'nprogress';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Module-scope flag: install the pushState proxy exactly once for the
// lifetime of the page. The previous render-time install nested a fresh
// Proxy around pushState on every render — eventually NProgress.start()
// fired many times per navigation, and the trickle setTimeout could fire
// after the container unmounted, throwing "Cannot read properties of null
// (reading 'className')" inside nprogress's addClass(parent, …).
// See SENTRY-COPPER-ELEPHANT-8.
let pushStatePatched = false;
const installPushStatePatch = () => {
  if (pushStatePatched) return;
  pushStatePatched = true;
  window.history.pushState = new Proxy(window.history.pushState, {
    apply: (target, thisArg, argArray: [any, string, (string | URL | null | undefined)?]) => {
      NProgress.start();
      return target.apply(thisArg, argArray);
    },
  });
};

export default function NavigationLoader(){

  const location = useLocation();

  // Drop the `parent:` setting entirely — it was the real cause of the
  // className crash. nprogress re-resolves the parent via
  // document.querySelector on EVERY trickle tick, and during React's
  // commit phase that lookup can return null even when the element exists
  // in the JSX. With no parent set, nprogress attaches to <body>, which
  // always exists. The `.bar` is `position: fixed` in the CSS, so visual
  // positioning is unaffected by losing the custom container.
  // See SENTRY-COPPER-ELEPHANT-8 / -5 / -W (one root cause, three groupings).
  useEffect(() => {
    NProgress.configure({ showSpinner: false });
    installPushStatePatch();
    return () => {
      NProgress.done();
    };
  }, []);

  useEffect(() => {
    NProgress.done();
  }, [location]);

  return (
    <Box
      id="nprogress-container"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 10,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        px: 0,
        height: '20px',
        pointerEvents: 'none',
        '--color': theme => theme.palette.primary.main
      }}
    />
  )
}